import { useDispatch, useSelector } from "react-redux";

import Loader from "components/loader";
import { RouterProvider } from "react-router-dom";
import { checkAuthStatus } from "store/src/thunks/auth-thunks";
import routes from "./router/index";
import { selectAuthStatus } from "store/src/slices/auth-slice";
import { useEffect } from "react";
import { Toaster } from "ui/components/sonner";

function App() {
  const dispatch = useDispatch();
  const authStatus = useSelector(selectAuthStatus);

  useEffect(() => {
    dispatch(checkAuthStatus());
  }, [dispatch]);

  if (authStatus === "loading") {
    return <Loader loaderHeight={24} loaderWidth={24} />;
  }

  return (
    <div>
      <RouterProvider router={routes} />
      <Toaster />
    </div>
  )
}

export default App;
